export default __webpack_public_path__ + "static/media/how it works.37971eea.png";